import ShiftHeader from "components/common/Scheduler/SchedulerRenderers/components/ShiftHeader";
import React from "react";
import renderToString from "./renderToString";

export default function shiftHeaderRenderer({ shiftInstance }) {
  return renderToString(<ShiftHeader shiftInstance={shiftInstance} />);
}
